import React, { FC } from 'react';
import { Form } from 'react-bootstrap';
import './Stepper.scss';

export interface Step {
  id: string;
  label: string;
  description?: string;
}

interface StepperComponentProps {
  steps: Step[];
  currentStep: string;
  onStepChange: (stepId: string) => void;
  className?: string;
}

const StepperComponent: FC<StepperComponentProps> = ({
  steps,
  currentStep,
  onStepChange,
  className = '',
}) => {
  const currentStepIndex = steps.findIndex(step => step.id === currentStep);

  const handleStepClick = (step: Step, index: number) => {
    // Solo permitir cambiar a pasos anteriores
    if (index < currentStepIndex) {
      onStepChange(step.id);
    }
  };

  return (
    <div className={`stepper-component ${className}`}>
      <div className="stepper-container">
        {steps.map((step, index) => {
          const isActive = step.id === currentStep;
          const isPrevious = index < currentStepIndex;
          const isClickable = isPrevious; // Solo los pasos anteriores son clickeables

          return (
            <div
              key={step.id}
              className={`stepper-step ${isActive ? 'active' : ''} ${isPrevious ? 'previous' : ''}`}
            >
              <div className="stepper-indicator-container">
                <Form.Check
                  type="radio"
                  id={`step-radio-${step.id}`}
                  name="stepperRadio"
                  checked={isActive}
                  onChange={() => isClickable && onStepChange(step.id)}
                  className="stepper-radio"
                  disabled={!isClickable && !isActive}
                />
                <div
                  className={`stepper-indicator ${isClickable ? 'clickable' : ''}`}
                  onClick={() => handleStepClick(step, index)}
                >
                  <span className="stepper-number">{index + 1}</span>
                </div>
                {index < steps.length - 1 && <div className="stepper-line"></div>}
              </div>
              <div
                className={`stepper-content ${isClickable ? 'clickable' : ''}`}
                onClick={() => handleStepClick(step, index)}
              >
                <div className="stepper-label">{step.label}</div>
                {step.description && <div className="stepper-description">{step.description}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepperComponent;